var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('the-w2-dialog',{attrs:{"visible":_vm.visible,"title":_vm.cfg.title,"width":_vm.cfg.width,"closeOnClickModal":false},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('iframe',{staticClass:"w2-org-iframe",attrs:{"src":_vm.cfg.url}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }